export const getErrorReason = (reason: unknown) => new Error(String(reason))
